import { render, staticRenderFns } from "./StatsContainerLanding.vue?vue&type=template&id=45c0fea6&scoped=true&"
import script from "./StatsContainerLanding.vue?vue&type=script&lang=js&"
export * from "./StatsContainerLanding.vue?vue&type=script&lang=js&"
import style0 from "./StatsContainerLanding.vue?vue&type=style&index=0&id=45c0fea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c0fea6",
  null
  
)

export default component.exports